<script>
import config from "@/config";

const routes = [
  {
    path: "/",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "/",
        redirect: "/login"
      },
      {
        path: "/login",
        component: () => import("@/views/default/_login.vue")
      },
      {
        path: "/logout",
        component: () => import("@/views/default/_logout.vue")
      },
      {
        path: "/expired",
        component: () => import("@/views/default/_expired.vue")
      },
      {
        path: "/denied",
        component: () => import("@/views/default/_denied.vue")
      },
      {
        path: "/firstTime",
        component: () => import("@/views/default/_firstTime.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/resetPassword",
        component: () => import("@/views/default/_resetPassword.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/security",
        component: () => import("@/views/default/_security.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/nekoBetDetail",
        component: () => import("@/views/default/_nekoBetDetail.vue"),
        props: true
      },
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true },
    children: [
      {
        path: "/settings",
        component: () => import("@/views/account/_settings.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/overview",
        component: () => import("@/views/account/_overview.vue"),
        meta: { requiredLoggedIn: true }
      }
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.editAccount, config.accessRoles.subAccount, config.accessRoles.editLimit, config.accessRoles.editOperatorLimit] },
    children: [
      {
        path: "/newAccount",
        component: () => import("@/views/account/_newAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      },
      {
        path: "/search",
        component: () => import("@/views/account/_search.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/subAccount",
        component: () => import("@/views/account/_subAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subAccount]}
      },
      {
        path: "/accountList",
        component: () => import("@/views/account/_accountList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.editLimit]}
      },
      {
        path: "/viewDownline",
        component: () => import("@/views/account/_viewDownline.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/adminList",
        component: () => import("@/views/account/_adminList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/socialAccount",
        component: () => import("@/views/account/_socialAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      },
    ]
  },
  {
    path: "/bank",
    component: () => import("@/views/bank/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount] },
    children: [
      {
        path: "/bank",
        redirect: "/bankAccount"
      },
      {
        path: "/bankAccount",
        component: () => import("@/views/bank/_bankAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      }
    ]
  },
  {
    path: "/report",
    component: () => import("@/views/report/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] },
    children: [
      // {
      //   path: "/report",
      //   redirect: "/settlementHistory"
      // },
      {
        path: "/settlementHistory",
        component: () => import("@/views/report/_settlementHistory.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/settlementHistoryDownline",
        component: () => import("@/views/report/_settlementHistoryDownline.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyStatementMember",
        component: () => import("@/views/report/_dailyStatementMember.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinlose",
        component: () => import("@/views/report/_dailyWinlose.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseAIO",
        component: () => import("@/views/report/_dailyWinloseAIO.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseByPlatformDetail",
        component: () => import("@/views/report/_dailyWinloseByPlatformDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/gameResultDetail",
        component: () => import("@/views/report/_gameResultDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseByProviderDetail",
        component: () => import("@/views/report/_dailyWinloseByProviderDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
    ]
  },
  {
    path: "/settlement",
    component: () => import("@/views/settlement/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlement] },
    children: [
      {
        path: "/settlement",
        redirect: "/settlementList"
      },
      {
        path: "/settlementList",
        component: () => import("@/views/settlement/_settlementList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlement]}
      }
    ]
  },
  {
    path: "/logs",
    component: () => import("@/views/logs/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] },
    children: [
      {
        path: "/logs",
        redirect: "/accessLog"
      },
      {
        path: "/accessLog",
        component: () => import("@/views/logs/_accessLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/memberLog",
        component: () => import("@/views/logs/_memberLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/accountLog",
        component: () => import("@/views/logs/_accountLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/positionTakingLog",
        component: () => import("@/views/logs/_positionTakingLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/commissionLog",
        component: () => import("@/views/logs/_commissionLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/betLimitLog",
        component: () => import("@/views/logs/_betLimitLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/settlementScheduleLog",
        component: () => import("@/views/logs/_settlementScheduleLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementScheduleLog] }
      },
      {
        path: "/promotionLog",
        component: () => import("@/views/logs/_promotionLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/providerLog",
        component: () => import("@/views/logs/_providerLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerLog] }
      },
      {
        path: "/walletLog",
        component: () => import("@/views/logs/_walletLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.walletLog] }
      },
    ]
  },
  {
    path: "/promotion",
    component: () => import("@/views/promotion/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotion] },
    children: [
      {
        path: "/promotion",
        redirect: "/promotionList"
      },
      {
        path: "/promotionList",
        component: () => import("@/views/promotion/_promotionList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotion] }
      }
    ]
  },
  {
    path: "/ticket",
    component: () => import("@/views/ticket/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket] },
    children: [
      {
        path: "/ticket",
        redirect: "/ticketList"
      },
      {
        path: "/ticketList",
        component: () => import("@/views/ticket/_ticketList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket] }
      }
    ]
  }
]

export default routes;
</script>
